import axios from "axios";
import { getToken } from "../services/storage.service";
import { ENV } from "../config/env";

const axiosClient2 = axios.create({
    baseURL: ENV.API_BASE_URL_KB,
    headers: {
        "Content-Type": "application/json",
    },
});

// Add token to headers
axiosClient2.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Handle responses / errors globally if needed
axiosClient2.interceptors.response.use(
    (response) => response,
    (error) => {
        // Example: handle 401 globally
        if (error.response?.status === 401) {
            // optionally logout or redirect
        }
        return Promise.reject(error);
    }
);

export default axiosClient2;
